/* eslint-disable react/prop-types */
import React, { useMemo } from 'react'
import styled from 'styled-components/macro'

export const Tiny = ({frames, frame, dim, status, percent}) => {
  const framesByKey = useMemo(() => {
    if (!Array.isArray(frames)) return {}
    return Object.fromEntries(frames.map((item) => {
      const key = Object.keys(item)[0]
      return [key, item[key]]
    }))
  }, [frames])

  const img = framesByKey?.[frame]
 
  const blur = Math.abs(percent-100)/3
  const opac = percent/100
  return (
    <>
      { status !== 'DONE' &&
        <StyledTiny
          src={img?.src}
          w={dim.W} 
          h={dim.H} 
          alt={''}
          style={{filter:`blur(${blur}px)`,opacity:opac}}/>
      }
    </>
  )

}

Tiny.displayName = 'Tiny'

const StyledTiny = styled.img`
  width: ${({ w }) => w}px;
  height: ${({ h }) => h}px;
  /* filter: ${({ blur }) => `blur(${blur}px)`}; */
  position: absolute;
`